<template>
  <span class="dot" :class="{ 'dot--imported': imported }"></span>
</template>
<script>
export default {
  props: ['imported']
}
</script>
<style lang="scss">
.dot {
  background: #b8b8b8;
  border: 1px solid darken(#b8b8b8, 15%);
  border-radius: 50%;
  display: inline-block;
  height: 10px;
  margin-right: 6px;
  width: 10px;

  &--imported {
    background: #60f454;
    border: 1px solid darken(#60f454, 15%);
  }
}
</style>